module.exports = __webpack_public_path__ + "static/img/rm_brand_img_luyiweisha_top.b568ccb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rm_brand_img/rm_brand_img_luyiweisha_top.png
// module id = zgv9
// module chunks = 1